import React from "react";
import { Checkbox } from "@progress/kendo-react-inputs";

export interface CountryListItem {
  name: string;
  checkBox: "Y" | "N";
}

export interface SupportCountryProps {
  countryList: CountryListItem[];
  onToggle: (name: string) => void;
  loading?: boolean;
  label?: string;
  className?: string;
  disabled?: boolean;
}

const SupportCountry: React.FC<SupportCountryProps> = ({
  countryList,
  onToggle,
  loading = false,
  label = "Supported Countries",
  className = "",
  disabled = false,
}) => {
  if (loading) {
    return (
      <div className={`animate-pulse ${className}`}>
        <div className="w-40 h-4 bg-gray-200 rounded" />
        <div className="flex gap-4 pt-4">
          {[1, 2, 3].map((i) => (
            <div key={i} className="w-24 h-4 bg-gray-200 rounded" />
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className={className}>
      <p className="gx-p14-b text-[#2E3338]">{label}</p>

      <div className="flex flex-wrap gap-2 pt-4">
        {countryList.length > 0 ? (
          countryList.map((country) => (
            <div
              key={country.name}
              className="flex items-center gap-2"
            >
              <Checkbox
                checked={disabled || country.checkBox === "Y"}
                onChange={() => onToggle(country.name)}
                disabled={disabled}
              />
              <span className="text-gray-900 gx-p14-m">
                {country.name}
              </span>
            </div>
          ))
        ) : (
          <p className="text-gray-400 gx-p14-m">
            No countries available.
          </p>
        )}
      </div>
    </div>
  );
};

export default SupportCountry;





